import './divider.scss'
import type { FC } from 'react'

interface DividerProps {
    isVisible?: boolean
    className?: string
}

export const Divider: FC<DividerProps> = ({ isVisible = true, className }) => {
    const propsClass = className ? ' ' + className : ''

    return isVisible ? <hr className={`grid-divider${propsClass}`} /> : null
}

export default Divider
